(function () {
    'use strict';

    angular
        .module('app.notesReportSchedule')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
            {
                state: 'notesreportschedule',
                config: {
                    url: '/notesreportschedule',
                    templateUrl: 'app/notesreportschedule/details.html?v=' + opsIncludeVersion,
                    controller: 'NotesReportScheduleController',
                    controllerAs: 'vm',
                    title: 'Notes Report Schedule'
                }
            }

        ];
    }
})();
